import { render, staticRenderFns } from "./PublishRoyalties.vue?vue&type=template&id=227a5bdc"
import script from "./PublishRoyalties.vue?vue&type=script&lang=js"
export * from "./PublishRoyalties.vue?vue&type=script&lang=js"
import style0 from "./PublishRoyalties.vue?vue&type=style&index=0&id=227a5bdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports